import * as swcHelpers from '@swc/helpers';
import { singletonMap } from '../SingletonMap/SingletonMap.js';

const reducersMap = singletonMap('reducers');
let listener;
const ReducersRegistry = {
    get reducers () {
        return swcHelpers.objectSpread({}, reducersMap);
    },
    set listener (l){
        listener = l;
    },
    register (name, reducer) {
        reducersMap[name] = reducer;
        if (listener) {
            listener(swcHelpers.objectSpread({}, reducersMap));
        }
    }
};

export { ReducersRegistry };
//# sourceMappingURL=ReducersRegistry.js.map
